<template>
    <section class="component register device-damage bg-white shadow-card rounded-lg p-8 mb-6">
        <header class="pt-2 pb-4 text-center">
            <h2 class="font-bold text-2xl md:text-3xl leading-none">Toestel &amp; Schade</h2>
        </header>

        <div class="py-4 md:py-10">

            <template v-if="fields.device_info ? fields.device_info.show : true">

                <div class="input-group sm:flex sm:flex-no-wrap">
                    <validation-provider v-slot="{ errors }" mode="eager" slim>
                        <div class="input-wrapper mb-3 w-full sm:w-6/12 sm:mr-3" :class="{ 'error': errors[0] }">
                            <label for="device_brand" class="block font-medium leading-6 text-black">Merk</label>
                            <div class="mt-1 relative rounded-md">
                                <input v-model.lazy="brand" id="device_brand" class="form-input border-none block w-full" :required="fields.device_info ? fields.device_info.require : false" />
                            </div>

                            <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                        </div>
                    </validation-provider>


                    <validation-provider v-slot="{ errors }" mode="eager" slim>
                        <div class="input-wrapper mb-3 w-full sm:w-6/12" :class="{ 'error': errors[0] }">
                            <label for="device_model" class="block font-medium leading-6 text-black">Model</label>
                            <div class="mt-1 relative rounded-md">
                                <input v-model.lazy="model" id="device_model" class="form-input border-none block w-full" :required="fields.device_info ? fields.device_info.require : false" />
                            </div>

                            <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                        </div>
                    </validation-provider>
                </div>

            </template>

            <template v-if="fields.serial_number ? fields.serial_number.show : true">

                <validation-provider v-slot="{ errors }" mode="eager" slim>
                    <div class="input-wrapper mb-3" :class="{ 'error': errors[0] }">
                        <label for="serial_number" class="block font-medium leading-6 text-black">Serienummer of IMEI</label>
                        <div class="mt-1 relative rounded-md">
                            <input v-model.lazy="serialNumber" id="serial_number" class="form-input border-none block w-full" :required="fields.serial_number ? fields.serial_number.require : false " />
                        </div>

                        <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                    </div>
                </validation-provider>

            </template>

            <validation-provider v-slot="{ errors }" mode="eager" slim>
                <div class="input-wrapper mb-3" :class="{ 'error': errors[0] }">
                    <label for="access_code" class="block font-medium leading-6 text-black">Toegangscode <small>(code of wachtwoord om uw toestel te ontgrendelen)</small></label>
                    <div class="mt-1 relative rounded-md">
                        <input v-model.lazy="accessCode" id="access_code" class="form-input border-none block w-full" />
                    </div>

                    <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                </div>
            </validation-provider>

            <validation-provider v-slot="{ errors }" mode="eager" slim>
                <div class="input-wrapper mb-3" :class="{ 'error': errors[0] }">
                    <label for="description" class="block font-medium leading-6 text-black">Omschrijving van de schade</label>
                    <div class="mt-1 relative rounded-md">
                        <textarea v-model.lazy="description" rows="6" id="description" class="form-input border-none block w-full resize-none" required />
                    </div>

                    <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                </div>
            </validation-provider>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        fields: Object
    },

    computed: {
        registrationFormData() {
            return this.$store.state.registrationForm;
        },

        brand: {
            get() { return this.registrationFormData.brand },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'brand', value }) }
        },

        model: {
            get() { return this.registrationFormData.model },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'model', value }) }
        },

        serialNumber: {
            get() { return this.registrationFormData.serial_number },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'serial_number', value }) }
        },

        accessCode: {
            get() { return this.registrationFormData.access_code },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'access_code', value }) }
        },

        description: {
            get() { return this.registrationFormData.description },
            set(value) { this.$store.commit('SET_REGISTRATION_FIELD', { property: 'description', value }) }
        }
    }
}
</script>

<style lang="scss" scoped>
.component.register.device-damage {

    header {
        border-bottom: 1px solid #DDDDDD;
    }
}
</style>
